<template>
  <div class="widget-card-content">
    <h2 class="content-title">{{title}}</h2>

    <div v-if="warning" class="warning-content">
      <h3 v-if="warning.title" class="warning-content-title bold">
        {{warning.title}}
      </h3>
      <p
          v-if="warning.text"
          class="warning-content-text"
      >
        {{warning.text}}
      </p>
    </div>

    <div v-if="expireText" class="widget-card-expire-text" v-html="expireText"/>

    <p v-if="text" class="widget-card-description">{{text}}</p>
  </div>
</template>

<script>

export default {
  name: 'WidgetCardPaymentInfo',
  props: {
    title: {
      type: String,
      default: null,
    },
    expireText: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    warning: {
      title: {
        type: String,
        default: null,
      },
      text: {
        type: String,
        default: null,
      },
    },
  },
  methods: {
    prepareUrl(url) {
      return url.replace(/^[a-z]+:\/\//i, '');
    },
    getTextHtml(text) {
      return text.replace(/\n/g, '<div class="widget-card-spacer"></div>');
    },
    getTooltipPosition() {
      const width = this.$store.state.windowWidth;
      if (width <= 480) {
        return 'is-bottom';
      }
      if (width <= 600) {
        return 'is-right';
      }
      if (width <= 1170) {
        return 'is-bottom';
      }
      return 'is-right';
    },
  },
};
</script>

<style lang="stylus" scoped>
.widget-card-content .content-title {
  margin-bottom: 30px;
  @media (max-width 480px) {
    margin-bottom: 26px;
  }
}

.warning-content {
  & .warning-content-title {
    font-size: 16px;
    line-height: 22.4px;
    color: #DE4B4B;
    margin: 0;
    margin-bottom: 20px;
  }
  & .warning-content-text {
    color: #525F66;
  }
  & .bold {
    font-weight: 900;
  }
}
.widget-card-expire-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 22.4px;
}
</style>
